import { FC } from 'react';
import styles from './styles.module.css';
import LoadingV2 from '../svg/LoadingV2';

export const LoaderV2: FC = () => {
  return (
    <div className={styles.container}>
      <LoadingV2 />
    </div>
  );
};
